import { render, staticRenderFns } from "./MpSortableV2.vue?vue&type=template&id=24f35a08&scoped=true&"
import script from "./MpSortableV2.vue?vue&type=script&lang=js&"
export * from "./MpSortableV2.vue?vue&type=script&lang=js&"
import style1 from "./MpSortableV2.vue?vue&type=style&index=1&id=24f35a08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f35a08",
  null
  
)

export default component.exports